"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var domUtils_1 = require("./domUtils");
/**
 * Inserting element after provided.
 *
 * @param newNode Node for inserting
 * @param afterNode Node after which the element is to be inserted
 */
function insertAfter(newNode, afterNode) {
    if (afterNode === afterNode.parentNode.lastChild) {
        afterNode.parentNode.appendChild(newNode);
    }
    else {
        afterNode.parentNode.insertBefore(newNode, afterNode.nextSibling);
    }
}
exports.insertAfter = insertAfter;
/**
 * Inserting element before provided.
 *
 * @param newNode Node for inserting
 * @param afterNode Node before which the element is to be inserted
 */
function insertBefore(newNode, afterNode) {
    afterNode.parentNode.insertBefore(newNode, afterNode);
}
exports.insertBefore = insertBefore;
/**
 * Hides element. Use show function to return previous value of inline display style
 */
function hide(element) {
    var el = element;
    if (getComputedStyle(el).display !== 'none') {
        if (el.wkShowHideRestore) {
            el.wkShowHideRestore();
            delete el.wkShowHideRestore;
        }
        else {
            var before_1 = el.style.display;
            el.style.display = 'none';
            el.wkShowHideRestore = function () { return el.style.display = before_1; };
        }
    }
}
exports.hide = hide;
/**
 * Shows element. Use hide function to return previous value of inline display style
 */
function show(element) {
    var el = element;
    if (getComputedStyle(el).display === 'none') {
        if (el.wkShowHideRestore) {
            el.wkShowHideRestore();
            delete el.wkShowHideRestore;
        }
        else {
            var before_2 = el.style.display;
            el.style.display = defaultStyle(el);
            el.wkShowHideRestore = function () { return el.style.display = before_2; };
        }
    }
}
exports.show = show;
/**
 * Returns default value of display property for given element
 */
function defaultStyle(element) {
    var el = document.createElement(element.tagName);
    var iframe = document.createElement('iframe');
    iframe.appendChild(el);
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var style = getComputedStyle(el).display;
    iframe.parentElement.removeChild(iframe);
    return style;
}
/**
 * Sets the offset of an element.
 * @param element Set the offset of this element
 * @param options Offset values
 */
function setElementOffset(element, options) {
    var props = {};
    var elementPosition = domUtils_1.getCss(element, 'position');
    if (elementPosition === 'static') {
        element.style.position = 'relative';
    }
    var currentOffset = domUtils_1.getElementOffset(element);
    var currentCSSTop = domUtils_1.getCss(element, 'top');
    var currentCSSLeft = domUtils_1.getCss(element, 'left');
    var calculatePosition = (elementPosition === 'absolute' || elementPosition === 'fixed')
        && (currentCSSTop + currentCSSLeft).indexOf('auto') > -1;
    var currentTop;
    var currentLeft;
    var currentPosition;
    if (calculatePosition) {
        currentPosition = domUtils_1.getElementPositionRectangle(element);
        _a = [currentPosition.top, currentPosition.left], currentTop = _a[0], currentLeft = _a[1];
    }
    else {
        _b = [parseFloat(currentCSSTop) || 0, parseFloat(currentCSSLeft) || 0], currentTop = _b[0], currentLeft = _b[1];
    }
    if (options.top !== null) {
        props.top = (options.top - currentOffset.top) + currentTop;
    }
    if (options.left !== null) {
        props.left = (options.left - currentOffset.left) + currentLeft;
    }
    element.style.top = props.top + 'px';
    element.style.left = props.left + 'px';
    var _a, _b;
}
exports.setElementOffset = setElementOffset;
/**
 * Adds a metatag to the document `<head>` and returns the created element.
 * @param name     Meta tag name
 * @param content  Meta tag content
 * @return         Meta tag element
 */
function addMeta(name, content) {
    var meta = document.createElement('meta');
    meta.setAttribute('name', name);
    meta.setAttribute('content', content);
    document.getElementsByTagName('head')[0].appendChild(meta);
    return meta;
}
exports.addMeta = addMeta;
